import { getAvailableOffers } from '../../../reducers/offers';
import { isFreeTrial, isEligibleForTrial } from '../../../helpers/subscription';

/**
 * Generic helper to check if a customer is eligible for trial for a specific product family
 * @param {Object} state - Redux state
 * @param {string} productFamily - The product family to check (e.g., 'identity', 'credit_expert')
 * @param {boolean} fallbackToGeneral - Whether to fall back to general trial eligibility if offer not found
 * @returns {boolean|undefined} - true/false if eligible, undefined if no offers data
 */
export const isEligibleForTrialByFamily = (state, productFamily, fallbackToGeneral = false) => {
  if (!state.offers.data) {
    return undefined;
  }

  const availableOffers = getAvailableOffers(state.offers, state.subscriptions);
  const familyOffer = availableOffers.find(offer => offer.family === productFamily);

  if (!familyOffer || !familyOffer.descriptors) {
    return fallbackToGeneral ? isEligibleForTrial(state) : false;
  }

  return isFreeTrial(familyOffer.descriptors);
};
